import { Component } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {RedemptionsService} from "@app/features/redemptions/redemptions.service";

@Component({
  selector: 'app-redemption-details',
  templateUrl: './redemption-details.component.html',
  styleUrls: ['./redemption-details.component.scss']
})
export class RedemptionDetailsComponent {

  public order: any;
  storeQrcode: any;

  constructor(public route: ActivatedRoute,
              public spinner: NgxSpinnerService,
              public redemptionsService: RedemptionsService) {
  }

  ngOnInit() {
    this.spinner.show().then(r => {});

    this.initOrderDetails(this.route.snapshot.params['id']);
  }

  public initOrderDetails(id:any) {
    this.redemptionsService.getRedemptionsDetails(id).subscribe(res => {
        this.order = res;
        this.storeQrcode = JSON.stringify({code: this.order.code});
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
  }
}
